"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasGlobalWebCrypto = void 0;
var hasGlobalThis = true;
try {
    hasGlobalThis = typeof globalThis !== "undefined";
}
catch (_a) {
    hasGlobalThis = false;
}
var _hasGlobalWebCrypto = hasGlobalThis;
if (hasGlobalThis) {
    try {
        _hasGlobalWebCrypto = (typeof globalThis.crypto !== "undefined" &&
            typeof globalThis.crypto.subtle !== "undefined");
    }
    catch (_b) {
        _hasGlobalWebCrypto = false;
    }
}
exports.hasGlobalWebCrypto = _hasGlobalWebCrypto;
